export default () => ({
    textField: {
        width: '100%'
    }
});
